<template>
  <div class="content-block">
    <ProjectTypeTable></ProjectTypeTable>
  </div>
</template>

<script>
import ProjectTypeTable from 'CORE/components/project/type/table'

export default {
    name: 'ProjectTypeList',
    components: {
        ProjectTypeTable,
    },
}
</script>
